import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the restoration of an board',
  name: 'restore_board',
  params: [
    {
      description: 'The ID of the restored board',
      name: 'board_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The name of the restored board',
      name: 'board_name',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
